import { type ITaxCodeCalculatorPayload } from "../components/TaxCodeCalculator/interfaces/ITaxCodeCalculatorPayload.interface";

export enum AllActionsEnum {
  CHANGE_SECTION = "CHANGE_SECTION",
  RESTORE_SECTION = "RESTORE_SECTION",
  UPDATE_QUESTIONNAIRE_REDIRECT_OPTIONS = "UPDATE_QUESTIONNAIRE_REDIRECT_OPTIONS",
  RESET_INITIAL_STATE_FORMS_AND_SET_CURRENT = "RESET_INITIAL_STATE_FORMS_AND_SET_CURRENT",
  CHANGE_CURRENT_FORM = "CHANGE_CURRENT_FORM",
  UPDATE_QUESTIONNAIRE = "UPDATE_QUESTIONNAIRE",
  RESET = "RESET",
  SHOW_GUIDED_MODE = "SHOW_GUIDED_MODE",
  UPDATE_GUIDED_MODE = "UPDATE_GUIDED_MODE",
  SET_TAX_CODE_DATA = "SET_TAX_CODE_DATA",
  SET_FORM_FIELD_ERROR = "SET_FORM_FIELD_ERROR",
  RESET_FORM_FIELD_ERROR = "RESET_FORM_FIELD_ERROR",
  UPDATE_FORM_FIELD_VALUE = "UPDATE_FORM_FIELD_VALUE",
  SET_CITIZEN_NAME = "SET_CITIZEN_NAME",
  SET_DEFAULT_FIRST_STEP_QUESTIONNAIRE_DATA = "SET_DEFAULT_FIRST_STEP_QUESTIONNAIRE_DATA",
  CHANGE_STEP = "CHANGE_STEP",
  CHANGE_STEP_NAME = "CHANGE_STEP_NAME",
  UPDATE_BROWSER_NAVIGATION_HISTORY = "UPDATE_BROWSER_NAVIGATION_HISTORY",
}

export interface StoreUpdates<T = RootStoreModule.State> {
  updates: T;
}

export interface IQuestionnaireRedirectOptionsProps {
  redirectOnEndSection?: string;
  redirectOnFinishSection?: string;
}

export enum ChangeSectionDirection {
  FORWARD = "FORWARD",
  BACKWARD = "BACKWARD",
}

export type ChangeSectionAction = {
  type: AllActionsEnum.CHANGE_SECTION;
  payload: { section?: string; direction?: ChangeSectionDirection; activeStepName?: string };
};
export type RestoreSectionAction = { type: AllActionsEnum.RESTORE_SECTION };
export type UpdateQuestionnaireRedirectOptionsAction = {
  type: AllActionsEnum.UPDATE_QUESTIONNAIRE_REDIRECT_OPTIONS;
  payload: IQuestionnaireRedirectOptionsProps;
};
export type ResetInitialStateFormsAndSetCurrentAction = {
  type: AllActionsEnum.RESET_INITIAL_STATE_FORMS_AND_SET_CURRENT;
  payload: { currentForm: string };
};
export type UpdateGuidedModeAction = {
  type: AllActionsEnum.UPDATE_GUIDED_MODE;
  payload: { value: boolean };
};
export type UpdateFormFieldValueAction = {
  type: AllActionsEnum.UPDATE_FORM_FIELD_VALUE;
  payload: { name: string; value: unknown };
};
export type SetFormFieldErrorAction = {
  type: AllActionsEnum.SET_FORM_FIELD_ERROR;
  payload: { name: string; value: unknown };
};
export type ResetFormFieldErrorAction = {
  type: AllActionsEnum.RESET_FORM_FIELD_ERROR;
};
export type ChangeStepAction = {
  type: AllActionsEnum.CHANGE_STEP;
  payload: { activeStep: number };
};
export type ChangeStepNameAction = {
  type: AllActionsEnum.CHANGE_STEP_NAME;
  payload: { activeStepName: string };
};
export type UpdateBrowserNavigationHistoryAction = {
  type: AllActionsEnum.UPDATE_BROWSER_NAVIGATION_HISTORY;
  payload: { values: any };
};
export type UpdateQuestionnaireAction = {
  type: AllActionsEnum.UPDATE_QUESTIONNAIRE;
  payload: { questionnaire: any; notify?: boolean };
};
export type SetCitizenNameAction = {
  type: AllActionsEnum.SET_CITIZEN_NAME;
  payload: { name: string };
};
export type SetDefaultFirstStepQuestionnaireDataAction = {
  type: AllActionsEnum.SET_DEFAULT_FIRST_STEP_QUESTIONNAIRE_DATA;
  payload: Partial<{
    taxCode: string;
    birthDate: string;
    prevDataDiNascita: string;
    mainActivity: number;
    birthPlace: string;
    registrySex: string;
    citizenshipCountries: string[];
  }>;
};
export type ResetAction = {
  type: AllActionsEnum.RESET;
};
export type ShowGuidedModeAction = {
  type: AllActionsEnum.SHOW_GUIDED_MODE;
  payload: { guidedMode: boolean };
};
export type SetTaxCodeDataAction = {
  type: AllActionsEnum.SET_TAX_CODE_DATA;
  payload: { taxCodeData: ITaxCodeCalculatorPayload };
};

export type AllActions =
  | ChangeSectionAction
  | RestoreSectionAction
  | UpdateQuestionnaireRedirectOptionsAction
  | ResetInitialStateFormsAndSetCurrentAction
  | UpdateGuidedModeAction
  | UpdateFormFieldValueAction
  | SetFormFieldErrorAction
  | ResetFormFieldErrorAction
  | ChangeStepAction
  | ChangeStepNameAction
  | UpdateBrowserNavigationHistoryAction
  | UpdateQuestionnaireAction
  | SetCitizenNameAction
  | SetDefaultFirstStepQuestionnaireDataAction
  | ResetAction
  | ShowGuidedModeAction
  | SetTaxCodeDataAction;
